import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PlatformErrorsTab from './components/PlatformErrorsTab';
import PlatformHealthTab from './components/PlatformHealthTab';
import PaymentAttemptsTab from './components/PaymentAttemptsTab';
import SystemLogsTab from './components/SystemLogsTab';
import AiApiLogsTab from './components/AiApiLogsTab';

type Tab = 'errors' | 'health' | 'payments' | 'system' | 'ai';

export default function SuperAdminLogsPage() {
  const [searchParams] = useSearchParams();
  const requested = searchParams.get('tab');
  const initialTab: Tab = requested === 'payments' || requested === 'system' || requested === 'health' || requested === 'ai'
    ? requested
    : 'errors';
  const [tab, setTab] = useState<Tab>(initialTab);

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-5">
        <div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">Journal système</h2>
          <p className="text-sm text-foreground-500 mt-1">
            Erreurs de la plateforme, paiements échoués et logs système : le détail réel de ce qui s’est passé.
          </p>
        </div>
        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-50 text-accent-700 text-[11px] font-medium whitespace-nowrap self-start md:self-auto">
          <i className="ri-record-circle-line animate-pulse"></i>
          Capture automatique active
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200/70 mb-6 w-fit max-w-full">
        {[
          { key: 'errors' as Tab, label: 'Erreurs plateforme', icon: 'ri-bug-line' },
          { key: 'payments' as Tab, label: 'Paiements échoués', icon: 'ri-secure-payment-line' },
          { key: 'system' as Tab, label: 'Logs système', icon: 'ri-terminal-line' },
          { key: 'health' as Tab, label: 'Santé de la plateforme', icon: 'ri-heart-pulse-line' },
          { key: 'ai' as Tab, label: 'Appels API IA', icon: 'ri-robot-2-line' },
        ].map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`flex items-center gap-1.5 px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
              tab === t.key ? 'bg-background-50 text-foreground-900 shadow-sm' : 'text-foreground-500 hover:text-foreground-800'
            }`}
          >
            <i className={`${t.icon} text-sm`}></i>
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'errors' && <PlatformErrorsTab />}
      {tab === 'payments' && <PaymentAttemptsTab />}
      {tab === 'system' && <SystemLogsTab />}
      {tab === 'health' && <PlatformHealthTab />}
      {tab === 'ai' && <AiApiLogsTab />}
    </div>
  );
}